import { SortOrder } from 'src/app/enum/sort-order';

export class SignatoryFilter {
    active: boolean;
    textSearch?: string;
    name?: string;
    skip: number;
    take: number;
    sortOrder: SortOrder;
    obfuscateMail?: boolean;
    obfuscateSsn?: boolean;
    obfuscateTelephone?: boolean;


    public EndRange(): number {
        return this.skip + this.take;
    }

    public InitRange(): number {
        return this.skip;
    }
}
